import { CommentReadDto } from "functions/api/comments/interface";

/**
 * Sort comments by their createdAt timestamp in descending order (newest first).
 *
 * @param a - The first comment object to compare
 * @param b - The second comment object to compare
 * @returns A negative number if b is newer, positive if a is newer, 0 if equal
 */
export const sortComments = (a: CommentReadDto, b: CommentReadDto): number => {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
};

/**
 * Sort comments by their createdAt timestamp in ascending order (oldest first).
 *
 * @param a - The first comment object to compare
 * @param b - The second comment object to compare
 * @returns A negative number if a is older, positive if b is older, 0 if equal
 */
export const sortCommentsAscending = (a: CommentReadDto, b: CommentReadDto): number => {
  return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
};
